import * as React from "react";

import { Item } from "DistributedTaskControls/Common/Item";
import * as  ReleaseEnvironmentPropertiesPanelAsync from "PipelineWorkflow/Scripts/ReleaseProgress/Canvas/ReleaseEnvironmentPropertiesPanel";
import { LoadingComponent } from "DistributedTaskControls/Components/LoadingComponent";
import { getAsyncLoadedComponent } from "VSS/Flux/AsyncLoadedComponent";

const ReleaseEnvironmentPropertiesPanelItem = getAsyncLoadedComponent(
    ["PipelineWorkflow/Scripts/ReleaseProgress/Canvas/ReleaseEnvironmentPropertiesPanel"],
    (ReleaseEnvironmentPropertiesPanelModule: typeof ReleaseEnvironmentPropertiesPanelAsync) => ReleaseEnvironmentPropertiesPanelModule.ReleaseEnvironmentPropertiesPanel,
    () => <LoadingComponent className="tab-loading-component" />);
    
export class ReleaseEnvironmentPropertiesItem implements Item {

    constructor(
        private _instanceId: string,
        private _environmentId: number,
        private _environmentDefinitionId: number,
        private _environmentName: string) {
    }

    public getOverview(instanceId?: string): JSX.Element {
        return null;
    }

    public getDetails(): JSX.Element {
        if (!this._details) {
            this._details = (<ReleaseEnvironmentPropertiesPanelItem
                    key={this.getKey()}
                    instanceId={this.getInstanceId()}
                    environmentId={this._environmentId}
                    environmentName={this._environmentName}
                    environmentDefinitionId={this._environmentDefinitionId} />);
        }
        
        return this._details;
    }

    public getKey(): string {
        return "cd-release-environment-properties-" + this.getInstanceId();
    }

    public getInstanceId(): string {
        return this._instanceId;
    }

    private _details: JSX.Element;
}
